import React from 'react';
import styles from './google-sign-in-button.scss';
import GoogleLogo from './images/google-logo.svg';
export var GoogleSignInButton = function (_a) {
    var onClick = _a.onClick, buttonText = _a.buttonText;
    return (React.createElement("div", { onClick: onClick, className: styles.googleButtonWrapper },
        React.createElement("div", { className: styles.googleLogoArea },
            React.createElement("img", { src: GoogleLogo })),
        React.createElement("span", { className: styles.googleButtonText }, buttonText)));
};
